import { ActivityHydrationStateEnum } from '../enums/activity-hydration-state.enum';

/**
 * Resolved record for a linked/unlinked activity event.
 */
export class ActivityLinkHydration {
  record?: Record<string, unknown>;
  hydrationState!: ActivityHydrationStateEnum;
  label?: string;
}
